import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=2dbb0392&scoped=true&"
import script from "./customTable.vue?vue&type=script&lang=ts&"
export * from "./customTable.vue?vue&type=script&lang=ts&"
import style0 from "./customTable.vue?vue&type=style&index=0&id=2dbb0392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb0392",
  null
  
)

export default component.exports